import { NAV_ITEMS_BASE_STUDENT } from "features/navbar/consts";
import { NavItemLink } from "features/navbar/types";
import { ROUTES } from "routing/routes";

const assignments: NavItemLink = {
  ...NAV_ITEMS_BASE_STUDENT.assignments,
  to: ROUTES.DASHBOARD.ASSIGNMENTS.buildPath({})
};

export default assignments;
